import React from "react";
import Socmed from "components/Socmed";

import DeveloperImage from "assets/images/author.png";
import IconEmail from "assets/images/ic_email.png";

export default function Profile() {
	return (
		<div className="mt-20 w-5/6 mx-auto">
			<div className="flex flex-col md:flex-row items-start justify-between">
				<div className="w-full md:w-2/5">
					<img
						className="w-[120px] h-[120px] block mx-auto md:mx-0"
						src={DeveloperImage}
						alt={DeveloperImage}
					/>
					<div className="text-xl font-medium mt-4 text-center md:text-left">
						Hariyanto
					</div>
					<div className="text-gray-500 text-center md:text-left">
						Front-End Developer
					</div>

					<div className="inline-flex items-center gap-5 mt-5 md:mt-16">
						<div>
							<img
								className="w-[50px] h-[50px]"
								src={IconEmail}
								alt={IconEmail}
							/>
						</div>
						<div>hariyannnn@gmail.com</div>
					</div>
				</div>
				<div className="w-full mt-8 md:mt-0 md:w-2/5">
					<div className="text-2xl font-light">
						Let me know if you want to talk about a potential
						collaboration, I’m available for freelance work.
					</div>
					<div className="text-xl font-medium my-8">
						Got a project ? Lets Talk
					</div>

					<Socmed />
				</div>
			</div>
		</div>
	);
}
